const data = [
    "adaptive_logo", //小屏幕上隐藏 'charts byTradingView' 文本
    "dont_show_boolean_study_arguments", //是否隐藏指标参数
    "hide_last_na_study_output", //隐藏最后一次指标输出
    "move_logo_to_main_pane", //logo在中间位置
    "same_data_requery", //允许您使用相同的商品调用 setSymbol 来刷新数据
    "hide_left_toolbar_by_defaul", //第一次打开图表时隐藏左工具栏
    "side_toolbar_in_fullscreen_mode", //使用此功能，您可以在全屏模式下启用绘图工具栏
    "disable_resolution_rebuild", //显示的时间与得到的数据时间一致
    "seconds_resolution",//支持秒的周期
    // 'hide_last_na_study_output', // 隐藏指标后面的 n/a
]


export default data;